// Canadian Schools Data - All schools have been reviewed and added to the database
export const canadianSchoolsData: Record<string, any> = {};